import { AsideService } from '@my-backoffice/app/pages/main/shared/components/aside/shared/services/aside.service';
import { OverlayComponent } from '@my-backoffice/app/shared/components/overlay/overlay.component';
import { WindowResizeService } from '@my-backoffice/app/shared/services/browser-services/window-resize/window-resize.service';
import { AppcuesService } from '@my-backoffice/app/shared/services/third-party-services/appcues/appcues.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { QimaResponsiveService } from '@qima/ngx-qima';
import { tap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-aside',
  standalone: true,
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OverlayComponent],
})
export class AsideComponent implements OnInit {
  public isAsideMenuVisible = false;
  public isAsideCollapsed = false;
  public isAppcuesBannerVisible = false;

  private _isMobile = false;

  public constructor(
    private readonly _appcuesService: AppcuesService,
    private readonly _asideService: AsideService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _qimaResponsiveService: QimaResponsiveService,
    private readonly _windowResizeService: WindowResizeService
  ) {}

  public ngOnInit(): void {
    this._watch();
  }

  public onOverlayClick(): void {
    this._asideService.updateAsideMenuVisible(false);
  }

  private _watch(): void {
    this._asideService.asideMenuVisible$.pipe(untilDestroyed(this)).subscribe((isVisible: boolean): void => {
      this.isAsideMenuVisible = isVisible;
      this._changeDetectorRef.markForCheck();
    });

    this._asideService.isAsideCollapsed$.pipe(untilDestroyed(this)).subscribe((isAsideCollapsed: boolean): void => {
      this.isAsideCollapsed = isAsideCollapsed;
      this._changeDetectorRef.markForCheck();
    });

    this._asideService.collapseMenuClick$.pipe(untilDestroyed(this)).subscribe((): void => {
      this.isAsideCollapsed = !this.isAsideCollapsed;
      this._asideService.updateIsAsideCollapsed(this.isAsideCollapsed);
      this._changeDetectorRef.markForCheck();
    });

    this._qimaResponsiveService
      .isMainNavBarCollapsed$()
      .pipe(untilDestroyed(this))
      .subscribe((isMatched: boolean): void => {
        this._asideService.updateIsAsideCollapsed(isMatched);
      });

    this._qimaResponsiveService
      .isMobile$()
      .pipe(untilDestroyed(this))
      .subscribe((isMobile: boolean): void => {
        this._isMobile = isMobile;

        if (isMobile) {
          this._asideService.updateIsAsideCollapsed(false);
        } else {
          this._asideService.updateIsAsideCollapsed(this._windowResizeService.getWidth() < 1720);
        }

        this._changeDetectorRef.markForCheck();
      });

    this._windowResizeService.widthBehaviourSubject$.pipe(untilDestroyed(this)).subscribe((width: number): void => {
      if (!this._isMobile) {
        this._asideService.updateIsAsideCollapsed(width < 1720);
        this._changeDetectorRef.markForCheck();
      }
    });

    this._appcuesService
      .appcuesEvent$()
      .pipe(
        tap({
          next: (isVisible: boolean): void => {
            this.isAppcuesBannerVisible = isVisible;
            this._changeDetectorRef.markForCheck();
          },
        }),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
